var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityLogLightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21.6,
    viewBox: "0 0 24 21.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M84.8-823.2h8.4v-2.4H84.8Zm12,0h2.4v-12H96.8Zm-12-4.8h8.4v-2.4H84.8Zm0-4.8h8.4v-2.4H84.8Zm-2.4,14.4a2.311,2.311,0,0,1-1.695-.705A2.311,2.311,0,0,1,80-820.8v-16.8a2.311,2.311,0,0,1,.705-1.7A2.311,2.311,0,0,1,82.4-840h19.2a2.311,2.311,0,0,1,1.695.705,2.311,2.311,0,0,1,.705,1.7v16.8a2.311,2.311,0,0,1-.705,1.7,2.311,2.311,0,0,1-1.695.705Z",
    transform: "translate(-80 840)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityLogLightIcon);
export default __webpack_public_path__ + "static/media/activity_log_light_icon.69dfe1d447d62d8d9cd41000f078c91e.svg";
export { ForwardRef as ReactComponent };